import { Avatar, Grid, Typography } from "@mui/material";
import { AppImageDimension } from "app/appImages";
import { MprcContainer, MprcLink } from "components";
import { CreateEnrollResults, EnrollStatus, TrainingSearchDto } from "generated/CoreApi_v1";
import * as React from "react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { LmsPaths } from "routes/LmsRouter";
import { resolveLmsTargetAction } from "views/general/Cards/CardDtoActions";
import { ICardDtoPathResult } from "views/general/Cards/Common";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: TrainingSearchDto;
    onBeforeLinkClick?: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderTraining: React.FC<IProps> = (props) => {
    const { data, onBeforeLinkClick } = props;
    const [dialog, setDialog] = useState<any>(null);
    const navigate = useNavigate();

    ///
    const handleCloseDialog = () => {
        setDialog(null);
    };

    ///
    const handleCloseDialogRegistration = (result: CreateEnrollResults | undefined) => {
        setDialog(null);
        if (result) {
            if (result.enrollmentId && result.enrollStatus == EnrollStatus.NotStarted) {
                navigate(LmsPaths.BuildEnrollmentViewer(data.trainingType!, result.enrollmentId));
            }
        }
    };

    ///
    const handleNavigate = (pathResult: ICardDtoPathResult) => {
        onBeforeLinkClick && onBeforeLinkClick();
        navigate(pathResult.url);
    };

    ///
    const handleAction = () => {
        if (data.actions.length > 0) {
            resolveLmsTargetAction(
                data.actions[0],
                data.data,
                setDialog,
                handleCloseDialogRegistration, handleCloseDialog, handleNavigate
            );
        }
    };

    ///
    return (
        <MprcContainer>
            {dialog}
            <Grid container spacing={2}>
                <Grid>
                    <Avatar
                        variant="rounded"
                        sx={{ width: AppImageDimension.ThumbnailLg.width / 2, height: AppImageDimension.ThumbnailLg.height / 2 }}
                        src={data.thumbnailUrl}
                    />
                </Grid>
                <Grid size="grow">
                    <MprcLink onClick={handleAction}>
                        <Typography variant="body1" color="primary.main" noWrap title={data.name}>
                            {data.name}
                        </Typography>
                    </MprcLink>

                    <Typography variant="caption">
                        <b>{data.contentTypeName}</b>
                    </Typography>

                    {
                        data.summary &&
                        <Typography variant="caption" component="div" color="muted.light">
                            {data.summary}
                        </Typography>
                    }
                </Grid>
            </Grid>
        </MprcContainer>
    );
};

export const SearchRenderShortTraining: React.FC<IProps> = (props) => {
    const { data, onBeforeLinkClick } = props;
    const [dialog, setDialog] = useState<any>(null);
    const navigate = useNavigate();

    ///
    const handleCloseDialog = () => {
        setDialog(null);
    };

    ///
    const handleCloseDialogRegistration = (result: CreateEnrollResults | undefined) => {
        setDialog(null);
        if (result) {
            if (result.enrollmentId && result.enrollStatus == EnrollStatus.NotStarted) {
                navigate(LmsPaths.BuildEnrollmentViewer(data.trainingType!, result.enrollmentId));
            }
        }
    };

    ///
    const handleNavigate = (pathResult: ICardDtoPathResult) => {
        onBeforeLinkClick && onBeforeLinkClick();
        navigate(pathResult.url);
    };

    ///
    const handleAction = () => {
        if (data.actions.length > 0) {
            resolveLmsTargetAction(
                data.actions[0],
                data.data,
                setDialog,
                handleCloseDialogRegistration, handleCloseDialog, handleNavigate
            );
        }
    };

    return (
        <MprcContainer>
            {dialog}
            <Grid container spacing={1}>
                <Grid>
                    <Avatar
                        variant="rounded"
                        sx={{ width: AppImageDimension.ThumbnailLg.width / 3, height: AppImageDimension.ThumbnailLg.height / 3 }}
                        src={data.thumbnailUrl}
                    />
                </Grid>
                <Grid size="grow">
                    <MprcLink onClick={handleAction}>
                        <Typography variant="h6" color="primary.main" noWrap title={data.name}>
                            {data.name}
                        </Typography>
                    </MprcLink>

                    <Typography variant="caption">
                        <b>{data.contentTypeName}</b>
                    </Typography>
                </Grid>
            </Grid>
        </MprcContainer>
    );
};
